<form
  *ngIf="form && initialized"
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="p-fluid">
  <app-header
    icon="fas fa-a"
    text="Beschriftung"
    sub="Wählen Sie die Standardbeschriftung Ihrer Tabellendarstellungen in Ihren Atlas."></app-header>
  <div class="grid">
    <app-form-field-wrapper
      [floatingLabel]="false"
      [hideLabel]="true"
      name="displayKeys"
      [colSize]="12">
      <p-checkbox
        formControlName="displayKeys"
        [binary]="true"
        label="Schlüssel abbilden"></p-checkbox>
    </app-form-field-wrapper>
    <app-form-field-wrapper name="captionTotal" [colSize]="6" label="Gesamt">
      <input pInputText name="captionTotal" formControlName="captionTotal" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      name="captionAverage"
      [colSize]="6"
      label="Durchschnitt">
      <input
        pInputText
        name="captionAverage"
        formControlName="captionAverage" />
    </app-form-field-wrapper>
    <app-form-field-wrapper
      name="captionDistrict"
      [colSize]="6"
      label="Teilraum">
      <input
        pInputText
        name="captionDistrict"
        formControlName="captionDistrict" />
    </app-form-field-wrapper>
    <app-form-field-wrapper name="captionKey" [colSize]="6" label="Schlüssel">
      <input pInputText name="captionKey" formControlName="captionKey" />
    </app-form-field-wrapper>
  </div>
</form>
